import { post } from "../../utils/BaseService";

export async function testMail(dispatch: any, input: any): Promise<any> {
    return await post(dispatch, '/emailSettings/testMail', input);
 };
export async function cronSetup(dispatch: any, input: any): Promise<any> {
    return await post(dispatch, '/emailSettings/cornSetup', input);
 };